import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './HeaderActions.module.scss';
import HeaderPopoverContent from './HeaderPopoverContent';

export default function HeaderActions() {
  const [activePopover, setActivePopover] = useState(null);
  const rootRef = useRef(null);

  const documentClickHandler = (e) => {
    if (rootRef.current.contains(e.target)) {
      return;
    }
    setActivePopover(null);
  };

  function scrollToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });

      setTimeout(() => {
        const inputElement = section.querySelector('input[type="email"]');
        if (inputElement instanceof HTMLInputElement) {
          inputElement.focus();
        }
      }, 500);
    }
  }

  useEffect(() => {
    window.document.addEventListener('click', documentClickHandler);
    return () => {
      window.document.removeEventListener('click', documentClickHandler);
    };
  }, []);

  const openSharePopover = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setActivePopover('share');
  }, []);

  const openReachOutPopover = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setActivePopover('reachOut');
  }, []);

  const closePopover = useCallback(() => {
    setActivePopover(null);
  }, []);

  const reachOutToUsClickHandler = (e) => {
    if (location.pathname !== '/') {
      openReachOutPopover(e);
    } else {
      scrollToSection('reachOutToUs');
    }
  };

  return (
    <div className={styles.root} ref={rootRef}>
      <div className={styles.popoverAnchor}>
        <button type="button" className={classNames(styles.button, styles.shareButton)} onClick={openSharePopover}>
          Share
        </button>
        {activePopover === 'share' && (
          <div className={styles.sharePopoverHolder}>
            <button type="button" className={styles.closePopoverButton} onClick={closePopover} aria-label="Close">
              x
            </button>
            <HeaderPopoverContent variant="share" />
          </div>
        )}
      </div>
      <div className={styles.popoverAnchor}>
        <button
          type="button"
          className={classNames(styles.button, styles.scheduleCallButton)}
          onClick={reachOutToUsClickHandler}
        >
          Reach out to us
        </button>
        {activePopover === 'reachOut' && (
          <div className={styles.sharePopoverHolder}>
            <button type="button" className={styles.closePopoverButton} onClick={closePopover} aria-label="Close">
              x
            </button>
            <HeaderPopoverContent variant="reachOut" />
          </div>
        )}
      </div>
    </div>
  );
}
